import React from 'react'
import { useQuery, gql } from '@apollo/client'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import GaugeChart from 'react-gauge-chart'

const useStyles = makeStyles(theme => ({
  leadCard: {
    height: '210px',
  },
  gaugeChartLabels: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '140px',
    fontWeight: '700',
    fontSize: '18px',
    position: 'relative',
    top: '20px',
    left: '-5px',
  },
  container: {
    marginTop: theme.spacing(1),
  },
}))

const getAverageTime = array => {
  let sum = 0
  let length = 0
  array.forEach(item => {
    const date1 = item.viewedAt ? new Date(item.viewedAt) : new Date()
    const date2 = new Date(item.createdAt)
    if (date1 !== date2) {
      const timeToRespond = Math.ceil(
        Math.abs(date1.getTime() - date2.getTime()) / (1000 * 60 * 60 * 24),
      )
      sum += timeToRespond
      length += 1
    }
    return sum
  })
  if (array.length) {
    return Math.ceil(sum / length)
  } else {
    return 0
  }
}

const LeadsWidget = () => {
  const GET_LEADS = gql`
    query CoachingLeads {
      coachingInquiries {
        id
        createdAt
        viewedAt
      }
    }
  `
  function useGetLeads() {
    return useQuery(GET_LEADS)
  }
  const { data: leadsData } = useGetLeads()
  const timeToRespond = leadsData
    ? getAverageTime(leadsData.coachingInquiries)
    : 0
  const leadsCount = leadsData ? leadsData.coachingInquiries.length : null
  const timeToRespondValue = (100 - timeToRespond * 10) / 100
  const chartStyle = {
    maxWidth: 300,
    maxHeight: 135,
  }
  const classes = useStyles()
  return (
    <Grid className={classes.container} container spacing={2}>
      <Grid item md={6} xs={12}>
        <Card>
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            className={classes.leadCard}
          >
            <Typography variant="h6" color="textPrimary" align="center">
              Total Leads
            </Typography>
            <Typography
              variant="h1"
              component="div"
              color="textPrimary"
              style={{ lineHeight: '1.6' }}
            >
              {leadsCount}
            </Typography>
          </Box>
        </Card>
      </Grid>
      <Grid item md={6} xs={12}>
        <Card>
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            className={classes.leadCard}
          >
            <Typography variant="h6" color="textPrimary" align="center">
              Average Days to Respond
            </Typography>
            <Box className={classes.gaugeChartLabels}>
              <div>7+</div>
              <div>3</div>
            </Box>
            <GaugeChart
              nrOfLevels={3}
              arcsLength={[0.3, 0.4, 0.3]}
              arcWidth={0.1}
              colors={[
                'rgb(255, 71, 26)',
                'rgb(239, 197, 33)',
                'rgb(150, 222, 42)',
              ]}
              percent={timeToRespondValue < 0 ? 0 : timeToRespondValue}
              textColor="#000000"
              formatTextValue={value => timeToRespond + ' Days'}
              style={chartStyle}
            />
          </Box>
        </Card>
      </Grid>
    </Grid>
  )
}

const MemoizedLeadsWidget = React.memo(LeadsWidget)

export default MemoizedLeadsWidget
